import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';

/**
 * Registro explícito de Chart.js.
 *
 * Se importa sólo lo que se usa —no `chart.js/auto`— y se empaqueta con la
 * aplicación: sin CDN (DEC-A13). Un corte de internet no debe apagar los gráficos
 * de una plataforma interna, ni cada carga debe informar a un tercero.
 */
let registered = false;

export function setupCharts(): void {
  if (registered) return;
  Chart.register(
    CategoryScale,
    LinearScale,
    BarController,
    BarElement,
    LineController,
    LineElement,
    PointElement,
    DoughnutController,
    ArcElement,
    Filler,
    Tooltip,
    Legend,
  );
  Chart.defaults.font.family = "'Segoe UI', system-ui, Arial, sans-serif";
  Chart.defaults.font.size = 11.5;
  Chart.defaults.animation = { duration: 320 };
  registered = true;
}
